<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('crudProdutosInternos.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="confirmDelete">{{
                messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <merus-data-table :headers="headers" :items="produtosInternos" :mostrar-inativos="mostrarInativos" :search="search" :loading="loadingtable"
      :loading-text="$t('crudProdutosInternos.loading')" dense class="elevation-7"
      locale="pt" style="border-radius: 10px" :default-multi-sort="defaultSort"

 cod-tabela="PRODUTOSINTERNOS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <cadastro-toolbar :title="$t('crudProdutosInternos.title')" :token="token" :items="produtosInternosFiltrados"
          csv-title="produtos_internos" @search="search = $event">
          <template v-slot:extension>
            <v-switch
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
          </template>
          <template v-slot:add>
            <v-dialog v-model="dialog" max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar dark color="primary" ref="myToolbar">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row style="padding-top: 10px;" justify="center">
                        <v-col cols="12" sm="6" md="4">
                          <v-select v-model="editedItem.id_tipo_equipamento" :items="tiposEquipamentos"
                            item-text="nome_tipo_equipamento" item-value="id_tipo_equipamento"
                            :label="$t('crudProdutosInternos.form.fields.tipoEquipamento')"
                            :rules="[tipoEquipamentoRules]" clearable></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.codigo_interno"
                            :label="$t('crudProdutosInternos.form.fields.codigoInterno')"
                            :rules="[codigoInternoRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.modelo"
                            :label="$t('crudProdutosInternos.form.fields.modelo')"
                            clearable></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="1">
                          <v-switch v-model="editedItemAtivo" class="ma-2"
                            :label="$t('crudProdutosInternos.form.fields.ativo')"
                            color="primary"></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </cadastro-toolbar>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-chip small :color="item.ativo === 1 || item.ativo === true ? 'green' : 'grey'" dark>
          {{ item.ativo === 1 || item.ativo === true ? $t('crudProdutosInternos.activeYes') : $t('crudProdutosInternos.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.nome_tipo_equipamento="{ item }">
        {{ item.nome_tipo_equipamento || '—' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import EventBus from "@/utils/eventBus";
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    loadingtable: true,
    search: "",
    mostrarInativos: false,
    produtosInternos: [],
    tiposEquipamentos: [],
    editedIndex: -1,
    editedItem: {
      id_produto_interno: null,
      id_tipo_equipamento: null,
      codigo_interno: null,
      modelo: null,
      ativo: true,
    },
    deletedItem: null,
    defaultItem: {
      id_produto_interno: null,
      id_tipo_equipamento: null,
      codigo_interno: null,
      modelo: null,
      ativo: true,
    },
  }),
  computed: {
    produtosInternosFiltrados() {
      if (!this.mostrarInativos) {
        return this.produtosInternos.filter((p) => p.ativo === true || p.ativo === 1);
      }
      return this.produtosInternos;
    },
    messageDismissButton() { return this.$t('button.dismiss'); },
    messageConfirmButton() { return this.$t('button.confirm'); },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('crudProdutosInternos.form.title.create')
        : this.$t('crudProdutosInternos.form.title.edit');
    },editedItemAtivo: {
      get() {
        return this.editedItem.ativo === 1 || this.editedItem.ativo === true;
      },
      set(val) {
        this.editedItem.ativo = val;
      },
    },
    defaultSort() {
      return [
        { value: 'nome_tipo_equipamento', options: { text: this.$t('system.labels.increasing'), value: 1 } },
        { value: 'codigo_interno', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaProdutosInternos();
    this.populaTiposEquipamentos();
  },
  mounted() {},
  methods: {

    tipoEquipamentoRules() {
      if (this.editedItem.id_tipo_equipamento == null || this.editedItem.id_tipo_equipamento === '') {
        return this.$t('crudProdutosInternos.form.validation.tipoEquipamentoRequired');
      }
      return true;
    },
    codigoInternoRules() {
      if (!validador(this.editedItem.codigo_interno, 1, 100, 1, 1)) {
        return this.$t('crudProdutosInternos.form.validation.codigoInternoRequired');
      }
      return true;
    },
    populaProdutosInternos() {
      apiController.request(apiController.endpoints.getallProdutosinternos, {
        onSuccess: (response) => {
          this.produtosInternos = response.data || [];
          this.loadingtable = false;
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    populaTiposEquipamentos() {
      apiController.request(apiController.endpoints.getallTiposequipamentos, {
        silent: true,
        onSuccess: (response) => {
          this.tiposEquipamentos = Array.isArray(response.data) ? response.data : [];
        },
        onError: () => {
          this.tiposEquipamentos = [];
        },
      });
    },
    editItem(item) {
      this.editedIndex = this.produtosInternos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.ativo = item.ativo === 1 || item.ativo === true;
      this.editedItem.id_tipo_equipamento = item.id_tipo_equipamento || null;
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = item;
      this.mensagemdialog = this.$t('crudProdutosInternos.messages.confirmDelete', {
        nome: item.codigo_interno || item.id_produto_interno,
      });
      this.confirmDialog = true;
    },
    confirmDelete() {
      if (!this.deletedItem) {
        this.confirmDialog = false;
        return;
      }
      const id = this.deletedItem.id_produto_interno;
      this.confirmDialog = false;
      this.deletedItem = null;
      apiController.request(apiController.endpoints.deleteProdutointerno, {
        params: { id },
        onSuccess: (response) => {
          if (response.data.erro) {
            EventBus.$emit('show-alert', { mensagem: this.$t('crudProdutosInternos.messages.errorDeletion'), tipo: 'error' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('crudProdutosInternos.messages.deletedSuccess'), tipo: 'success' });
          }
          this.populaProdutosInternos();
        },
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = null;
        this.editedIndex = -1;
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        const payload = {
          id_tipo_equipamento: this.editedItem.id_tipo_equipamento,
          codigo_interno: (this.editedItem.codigo_interno || '').trim(),
          modelo: (this.editedItem.modelo || '').trim() || null,
          ativo: this.editedItem.ativo === 1 || this.editedItem.ativo === true ? 1 : 0,
        };
        if (this.editedIndex === -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertProdutointerno, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        } else {
          payload.id_produto_interno = this.editedItem.id_produto_interno;
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateProdutointerno, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    updateTable(status) {
      let mensagem = "";
      const tipo = status ? "error" : "success";
      if (status) {
        if (this.operacao === 0) {
          mensagem = this.$t('crudProdutosInternos.messages.errorInclusion');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudProdutosInternos.messages.errorUpdate');
        } else {
          mensagem = this.$t('crudProdutosInternos.messages.errorDeletion');
        }
      } else {
        if (this.operacao === 0) {
          mensagem = this.$t('crudProdutosInternos.messages.includedSuccess');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudProdutosInternos.messages.updatedSuccess');
        } else {
          mensagem = this.$t('crudProdutosInternos.messages.deletedSuccess');
        }
        this.editedItem = Object.assign({}, this.defaultItem);
      }
      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.populaProdutosInternos();
    },
  },
};
</script>
